import './ProfileRow.css';

export function _ProfileRow({index, label, value}) {
    return (
        <div className={`profile-row ${index === 0 ? 'first-row' : ''}`}>
            <span className="profile-label">
                {label}
            </span>
            <span className="profile-value">
                {value}
            </span>
        </div>
    )
}
